module.exports = __webpack_public_path__ + "media/images/cleaning/pro1@2x-e2236d4e3f2c9af4a00a4c72d7136328.jpg";